import { Roles } from 'constants/roles';

const Routes = {
  Base: '/',
  Signin: '/signin',
  Signup: '/signup',
  VerifyEmail: '/verify',
  Profile: '/profile',
  ProfileEmail: '/email',
  ProfilePublish: '/publish',
  Dashboard: '/dashboard',
  Datasets: '/datasets',
  Arts: {
    Base: '/arts',
    CreateArt: '/arts/create',
    UpdateArt: '/arts/update/:productId',
  },
  Widgets: {
    Base: '/widgets',
  },
};

const BaseRoutes = [
  {
    path: Routes.Dashboard,
    availableForRoles: [Roles.Admin, Roles.Artist],
  },
  {
    path: Routes.Datasets,
    availableForRoles: [Roles.Admin, Roles.HrManager],
  },
  {
    path: Routes.Arts.Base,
    availableForRoles: [Roles.Admin, Roles.Artist, Roles.Moderator],
  },
  {
    path: Routes.Widgets.Base,
    availableForRoles: [Roles.Artist],
  },
  {
    path: Routes.Profile,
    availableForRoles: [Roles.Admin, Roles.Artist, Roles.HrManager, Roles.Moderator],
  },
  {
    path: Routes.ProfileEmail,
    availableForRoles: [Roles.Admin, Roles.Artist, Roles.HrManager, Roles.Moderator],
  },
  {
    path: Routes.ProfilePublish,
    availableForRoles: [Roles.Admin, Roles.Artist, Roles.HrManager, Roles.Moderator],
  },
];

export { Routes, BaseRoutes };
